export default "__VITE_ASSET__HT5XqR1U__";